// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"a8b60853","368":"a8b60853","492":"1787106c","527":"05af289f","633":"8a5ae784","640":"a8b60853","769":"a8b60853","806":"a8b60853","812":"1a4dc232","917":"a8b60853"}[chunkId] + ".css";
};